const marka = { t: 'Marka', name: 'do-marki', hint: { url: '/part_make', deps: ['pojazd'] }}
export default marka